import conditionals from './conditionals/index';

const subjects = { conditionals };

export default subjects;
